<template>
  <div>
    <h2 class="my-5">
      <b>Processed Files</b>
    </h2>
    <table>
      <tr>
        <th>Filename</th>
        <th>Type</th>
        <th>Date</th>
        <th>Price</th>
      </tr>
      <tr v-for="item in summaryItems" :key="item.captureID" class=" ">
        <td>{{ item.filename }}</td>
        <td>{{ item.type }}</td>
        <td>{{ item.timestamp }}</td>
        <td>
          <b>{{ webArchivePrice }} INR</b>
        </td>
      </tr>
      <tr>
        <th class="pt-5">Sub Total</th>
        <td />
        <td />
        <td>
          <b>{{ subTotal() }} INR</b>
        </td>
      </tr>
      <tr v-show="discountPercent">
        <th>
          Promo and discounts <i class="ml-2 fa fa-certificate promo-yellow" />
        </th>
        <td />
        <td />
        <td class="price-green">
          <b> - {{ discount() }} INR</b>
        </td>
      </tr>
      <tr>
        <th class="pt-5">Total</th>
        <td />
        <td />
        <td class="pt-5">
          <h3>
            <b>{{ total() }} INR</b>
          </h3>
        </td>
      </tr>
    </table>
    <div class="d-flex pt-5">
      <button class="btn next-btn ml-0 mr-auto" @click="nextHandler(4)">
        Next <i class="fa fa-angle-right ml-2" />
      </button>
    </div>
  </div>
</template>
<script>
export default {
  name: "Summary",
  props: {
    summaryItems: Array,
    nextHandler: Function,
  },
  data() {
    return {
      webArchivePrice: 100,
      discountPercent: 0,
    }
  },
  methods: {
    subTotal() {
      return this.webArchivePrice * this.summaryItems.length
    },
    discount() {
      return (this.discountPercent * this.subTotal()) / 100
    },
    total() {
      return this.subTotal() - this.discount()
    },
  },
}
</script>
<style scoped>
table {
  width: 100%;
  border: none;
  border-collapse: collapse;
  text-indent: initial;
  border-spacing: 2px;
  display: table;
  text-align: left;
}

td,
th {
  padding: 0.5rem;
}

td:last-child,
th:last-child {
  text-align: right;
}

.price-green {
  color: #06b477;
}

.promo-yellow {
  color: #f3db00;
}
</style>


// WEBPACK FOOTER //
// src/components/Summary.vue